// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2I5Uo","rightAdornment":"Header_rightAdornment__27KEY"};